<div class="container">
  <div class="sidenav-second-level my-5">
    <div class="row gap-4 gap-lg-0">
      <div class="col-lg-4">
        <multisite-vertical-menu-type-one
        [navigationLinks]="navigationLinks"
        [pictureEditable]="false"
        [nameText]="user ? user.fname+' '+user.lname : '[No name]'"
        [picture]="user | userAvatar"
        >
        </multisite-vertical-menu-type-one>
      </div>
      <div class="col-lg-8">
        <user-connections-details-update
          [user]="user"
          [loading]="loading"
          [error]="error"
        >
        </user-connections-details-update>     
      </div>
    </div>
  </div>
</div>